(ns rothko.theme.manatee.collection-components.table
  (:refer-clojure :exclude [rem])
  (:require [garden.units :as units :refer [rem px]]
            [rothko.theme.manatee.colours :refer [colours]]))

(def grey-border [[(:grey-10 colours) :solid (px 1)]])
(def padding (rem 1))

(def body
  {:primary
   {:border grey-border}})

(def column-name
  {:primary
   {:padding padding
    :column-name-font-weight :bold
    :column-name-display :flex
    :field-filter-icon-margin :auto}})

(def field
  {:primary
   {:padding [[padding (rem 1.5)]]}})

(def footer
  {:primary
   {:border grey-border
    :padding padding
    :padding-top (rem 0.4)}})

(def header
  {:primary
   {:border grey-border
    :border-bottom :none}})

(def row
  {:primary
   {:background-color--hover (:grey-3 colours)}
   :selected
   {:outline [[(:blue-light colours) :solid (px 3)]]}})
